import { QueryKeys } from "@/constants/Query";
import type { AoeQuestionnaire } from "@/features/Charting/components/Labs/types";
import type { AoeQuestionAnswerType } from "@/features/Charting/components/Labs/types";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";

interface DxReportOrderAOEParams {
  patientId: string;
  requestGroupId: string;
}

export interface AnswerCoding {
  code: string;
  display: string;
}

export interface Answer {
  answerType: AoeQuestionAnswerType;
  answerValue: string | AnswerCoding;
}

interface AoeQuestionResponse {
  linkId: string;
  question: string;
  answers: Answer[];
}

export interface QuestionnairesWithResponses {
  serviceRequestId: string;
  labTestCode: string;
  questionnaire: AoeQuestionnaire;
  questionResponses: AoeQuestionResponse[];
  testName: string;
  requiredAoeQuestionsAnswered: boolean;
}

interface LabsOrderAOEQuestionnaireResponse {
  testQuestionnairesResponses: QuestionnairesWithResponses[];
  requiredAoeQuestionsAnswered: boolean;
}

export const useDxReportOrderAOE = ({
  patientId,
  requestGroupId,
}: DxReportOrderAOEParams) => {
  return useApi<LabsOrderAOEQuestionnaireResponse>({
    queryOptions: {
      enabled: Boolean(requestGroupId),
      queryFn: async () => {
        const response =
          await axiosInstance.get<LabsOrderAOEQuestionnaireResponse>(
            `/labs/order/${requestGroupId}/aoe`,
          );

        return response.data;
      },
      queryKey: QueryKeys.Patient.MedicalRecords.Labs.ORDER_AOE(
        patientId,
        requestGroupId,
      ),
    },
  });
};
